import { UnitType } from '@exodus/currency'

const name = 'qtumignition'
const displayName = 'Qtum'
const ticker = 'QTUM'
const displayTicker = ticker
const displayNetworkTicker = displayTicker
const displayNetworkName = displayName
const baseAssetName = name
const primaryColor = '#2E9AD0'
const gradientColors = ['#2E9AD0', '#13628A']
const gradientCoords = { x1: '4.374%', y1: '4.331%', x2: '102%', y2: '101%' }
const chainBadgeColors = gradientColors

const units = {
  satoshis: 0,
  QTUM: 8,
}
const currency = UnitType.create(units)

const assetType = 'BITCOIN_LIKE'
const blockExplorer = {
  addressUrl: (address) => `https://explorer.qtum.org/address/${address}`,
  txUrl: (txId) => `https://explorer.qtum.org/tx/${txId}`,
}
const info = {
  description:
    'Qtum is a cryptocurrency designed to link Ethereum smart contracts with the stability of the Bitcoin blockchain.',
  reddit: 'https://www.reddit.com/r/Qtum/',
  twitter: 'https://twitter.com/QtumOfficial',
  website: 'https://www.qtum.org/',
}

export const tokens = undefined
export const asset = {
  assetType,
  baseAssetName,
  blockExplorer,
  chainBadgeColors,
  currency,
  displayName,
  displayNetworkName,
  displayNetworkTicker,
  displayTicker,
  gradientColors,
  gradientCoords,
  info,
  name,
  primaryColor,
  properName: displayName, // deprecated,
  properTicker: displayTicker, // deprecated,
  ticker,
  toString: () => name,
  units,
}

export default [asset]
